import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider, FormControl, FormControlLabel, FormLabel, Grid, IconButton, Radio, RadioGroup } from "@material-ui/core"
import React from "react"
import CloseIcon from '@material-ui/icons/Close';
import { Edit } from "@material-ui/icons";

import { useQueryClient } from "react-query";
import { toast } from "react-toastify";
import { set } from "lodash";
import { useAssignRSD } from "../../../../dataEgress/dataEgressMutations";
import { useFetchContext } from "../../../../common/FetchContext";
import { useAvailableTSD } from "../../../../testCommunication/common/testQueries";
import { TsdTestSequenceDialog } from "./TsdTestSequenceDialog";


export const TsdDefineDataDialog = ({openTsd,handleClose}:any) => {
  const { mutateAsync: mutateRsd } = useAssignRSD();
  const { authAxios } = useFetchContext();  
  const queryClient = useQueryClient()
    const [openCustomeDialog, setOpenCustomeDialog] = React.useState(false);
    const [openTsDialog, setOpenTsDialog] = React.useState(false);
    const [openConfirmDialog, setOpenConfirmDialog] = React.useState(false);

    const [value, setValue] = React.useState("");

    const handleChange = (e: { target: { value: React.SetStateAction<string>; }; }) => {
            setValue(e.target.value);
            console.log("Selected:", e.target.value);
            setOpenConfirmDialog(!openConfirmDialog);
            handleClose(e.target.value);
        };

        const handleCloseCustomDialog = () => {
            
            setOpenCustomeDialog(!openCustomeDialog);
        };

        const closeTsdDialog = () => {
            setOpenTsDialog(!openTsDialog);
        };
    const {
        error: errorUnits,
        data: tsdData,
        isError: isErrorUnits,
        isSuccess: isSuccessUnits,
        isLoading: isLoadingUnits,
    } = useAvailableTSD();
   
 

    return (
        <>
            <Dialog
                open={openTsd}
                onClose={handleClose}
                aria-labelledby="scroll-dialog-title"
                aria-describedby="scroll-dialog-description"
                fullWidth={false}>
                <DialogTitle id="id">
                    <div>
                        <Box display="flex" alignItems="center">
                            <Box flexGrow={1} >Define Data Readiness</Box>
                            <Box>
                                <IconButton onClick={handleClose}>
                                    <CloseIcon />
                                </IconButton>
                            </Box>
                        </Box>

                    </div>
                </DialogTitle>

                <DialogContent>
                    <Grid container spacing={3}>
                        <Grid item xs={12}>
                            <Button
                                variant="contained"
                                color="primary"
                                fullWidth
                                onClick={() => { setOpenCustomeDialog(!openCustomeDialog) }}
                            >
                                CUSTOM DEFINITION
                            </Button>
                        </Grid>
                        <Grid item xs={12}>
                            <Button
                                variant="contained"
                                color="primary"
                                fullWidth
                                onClick={() => { setOpenTsDialog(!openTsDialog) }}
                            >
                                TEST DEFINITION
                            </Button>
                        </Grid>
                    </Grid>

                </DialogContent>

                <DialogActions>
                </DialogActions>
            </Dialog>



            <Dialog
                open={openCustomeDialog}
                onClose={handleCloseCustomDialog}
                aria-labelledby="scroll-dialog-title"
                aria-describedby="scroll-dialog-description"
                fullWidth={false}>
                <DialogTitle id="id">
                    <div>
                        <Box display="flex" alignItems="center">
                            <Box flexGrow={1} >Choose Event Type</Box>
                            <Box>
                                <IconButton onClick={handleCloseCustomDialog}>
                                    <CloseIcon />
                                </IconButton>
                            </Box>
                        </Box>

                    </div>
                </DialogTitle>

                <DialogContent>
                    <Grid container spacing={1}>
                        <FormControl>
                            <FormLabel>Select an Option</FormLabel>

                            <RadioGroup value={value} onChange={handleChange}>
                                <FormControlLabel value="Module Intake" control={<Radio />} label="Module Intake" />
                                <FormControlLabel value="Factory witness" control={<Radio />} label="Factory witness" />
                            </RadioGroup>

                        </FormControl>

                    </Grid>

                </DialogContent>

                <DialogActions>
                    <Button  onClick={() => { 
                          if(value!=''){
                            setOpenConfirmDialog(true)

                          }else{
                              toast.success("Please select an option");
                  
                          }
                         }}>Confirm</Button>
                </DialogActions>
            </Dialog>


            <Dialog
                open={openTsDialog}
                onClose={closeTsdDialog}
                aria-labelledby="scroll-dialog-title"
                aria-describedby="scroll-dialog-description"
                fullWidth={true}>
                <DialogTitle id="id">
                    <div>
                        <Box display="flex" alignItems="center">
                            <Box flexGrow={1} >Choose Test Sequence Definitions</Box>
                            <Box>
                                <IconButton onClick={closeTsdDialog}>
                                    <CloseIcon />
                                </IconButton>
                            </Box>
                        </Box>

                    </div>
                </DialogTitle>

                <DialogContent>
                    <Grid container spacing={1}>
                         {console.log("TSD DATA",tsdData)}
                        <TsdTestSequenceDialog tsdData={tsdData} handleClose={handleClose}  />
                    </Grid>

                </DialogContent>

            </Dialog>

        </>
    )
}